import React from "react";
import { useState, useEffect } from "react";
import dynamic from 'next/dynamic'
import Head from 'next/head';
import Image from 'next/image'
import Navbar from '../components/Layouts/Navbar';
import { useRouter } from 'next/router';

const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
import algoliasearch from 'algoliasearch/lite';
import { useSelector, useDispatch } from 'react-redux';
import * as Yup from "yup";
import CallBackForm from "../components/Common/CallBackForm";
import Link from "next/link";
import Toast from '../components/Common/Toast'
import {
  InstantSearch,
  Pagination,
  SearchBox,
  connectHits,
  Highlight,
  Configure,
  connectStats,
  VoiceSearch,
  connectStateResults,
  SortBy,
  RefinementList,
  ClearRefinements,
  connectRange,
} from 'react-instantsearch-dom';
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faXmark,
  faFile,
  faCartShopping,
  faCreditCard,
  faChartLine,
  faMagnifyingGlass,
  faChevronDown,
  faChevronRight, faHome,
  faAngleDown, faFilter
} from '@fortawesome/free-solid-svg-icons';
import Slider from '@mui/material/Slider';
import axios from 'axios';
import { addItemToCart } from '../components/Store/reducers/cartSlice';

import { useAddCartMutation, useGetCartMutation } from '../components/Store/Features/CartAPI';
import SectionHeading from "../components/Common/SectionHeading";
import { useMediaQuery } from 'react-responsive';
import BuyNow from "../components/ReportStore/BuyNow";


const ReportStore = ({ data, slug = null }) => {
  const dispatch = useDispatch();
  // const mainKey = 'UKQLSUI7R1'
  // const securityKey = 'aaf591635871a36919ac0f78f7c1fd8a'
  const mainKey = process.env.ALGOLIA_APP_ID;
  const securityKey = process.env.ALGOLIA_APP_SECRET_KEY;

  const router = useRouter();

  const [defaultCategory, setDefaultCategory] = useState(null);

  const [defaultTharea, setDefaultTharea] = useState(null);

  const [defaultTag, setDefaultTag] = useState(null);
  const [isAdded, setIsAdded] = useState(false);

  useEffect(() => {
    const { query } = router;
    const selectedCategory = query.category;
    const selectedTharea = query.therapeutic_areas;
    const selectedTag = query.tag;

    if (selectedCategory) {
      setDefaultCategory(selectedCategory);
    }

    if (selectedTharea) {
      setDefaultTharea(selectedTharea);
    }

    if (selectedTag) {
      setDefaultTag(selectedTag);
    }

  }, [router]);

  const searchClient = algoliasearch(mainKey, securityKey);
  const [query, setQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [addCart, { isError, isSuccess }] = useAddCartMutation();

  const isDesktop = useMediaQuery({ minWidth: 784 });
  const [expanded, setExpanded] = useState(isDesktop);

  const [expandedStates, setExpandedStates] = useState([false, false, false, false, false, false]);

  const togglePanel = (index) => {
    const newExpandedStates = [...expandedStates];
    newExpandedStates[index] = !newExpandedStates[index];
    setExpandedStates(newExpandedStates);
  };

  const toggleSection = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    setExpanded(isDesktop);
  }, [isDesktop]);


  const [getCart, { isError: Err }] = useGetCartMutation();


  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 500);
  }, [])

  

  const [top, setTop] = useState(true)

  const toastConfig = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const DateRangeSlider = ({ min = 1514764800, max = Math.floor(Date.now() / 1000), currentRefinement, refine }) => {
    const [minValue, setMinValue] = React.useState(currentRefinement.min);
    const [maxValue, setMaxValue] = React.useState(currentRefinement.max);

    const handleSliderChangeDate = (_, newValue) => {
      setMinValue(newValue[0]);
      setMaxValue(newValue[1]);
      setTop(false)
    };

    const resetFilters = () => {
      setMinValue(min);
      setMaxValue(max);
      refine({ min, max });
      setTop(false)
    };

    React.useEffect(() => {
      refine({ min: minValue, max: maxValue });
    }, [minValue, maxValue, refine]);

    const formatTimestamp = (timestamp) => {
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        timeZone: 'UTC',
      });
    };

    const getAriaValueText = (values) => {
      return `${formatTimestamp(values[0] * 1000)} - ${formatTimestamp(values[1] * 1000)}`;
    };

    return (
      <div>
        <button onClick={resetFilters} className="bg-[#1e5df3] mb-2 hover:bg-[#1b5df3] text-white font-semibold py-1 px-4 rounded text-[12px]">Reset</button>
        <div className="flex justify-between text-sm font-semibold">
          <div>{formatTimestamp(minValue)}</div>
          <div>{formatTimestamp(maxValue)}</div>
        </div>
        <Slider
          getAriaLabel={() => 'Date range'}
          onChange={handleSliderChangeDate}
          value={[minValue, maxValue]}
          valueLabelDisplay="off"
          getAriaValueText={getAriaValueText}
          min={min}
          max={max}
        />
      </div>
    );
  };

  const CustomDateRangeSlider = connectRange(DateRangeSlider);



  const PriceRangeSlider = ({ min, max, currentRefinement, refine }) => {
    const [minValue, setMinValue] = React.useState(currentRefinement.min);
    const [maxValue, setMaxValue] = React.useState(currentRefinement.max);

    const handleSliderChange = (_, newValue) => {
      setMinValue(newValue[0]);
      setMaxValue(newValue[1]);
      setTop(false)
    };

    const resetFilters = () => {
      setMinValue(min);
      setMaxValue(max);
      refine({ min, max });
      setTop(false)
    };

    React.useEffect(() => {
      refine({ min: minValue, max: maxValue });
    }, [minValue, maxValue, refine]);

    const getAriaValueText = (value) => `${value}`;


    return (
      <div>
        <button onClick={resetFilters} className="bg-[#1e5df3] mb-2 hover:bg-[#1b5df3] text-white font-semibold py-1 px-4 rounded text-[12px]">Reset</button>
        <div className="flex justify-between text-sm font-semibold">
          <div>${minValue}</div>
          <div>${maxValue}</div>
        </div>
        <Slider
          getAriaLabel={() => 'Price range'}
          onChange={handleSliderChange}
          value={[minValue !== undefined ? minValue : 0, maxValue !== undefined ? maxValue : 45000]}
          valueLabelDisplay="off"
          getAriaValueText={getAriaValueText}
          min={min}
          max={max}
          color="primary"
        />
      </div>
    );
  };


  const CustomPriceRangeSlider = connectRange(PriceRangeSlider);


  const CustomHits = connectHits(({ hits }) => (
    <>
      {hits &&
        <div className="grid grid-cols-12 gap-4">
          {hits.map((hit, index) => (
            <div key={index} className="col-span-12 p-2 border rounded shadow lg:p-4">
              <div className="flex justify-between w-full gap-2 lg:gap-4">
                <div className="relative flex items-center text-center">
                  <Link href={process.env.APP_URL + `/report-store/${hit.slug}`} target="_blank">
                    <Image
                      priority={true}
                      className="h-30 w-28"
                      alt="report image delveinsight"
                      src={
                        hit.image !== '' ? process.env.IMG_CDN + hit.image :
                          hit.featured_image !== '' ? process.env.IMG_CDN + hit.featured_image :
                            process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'
                      }
                      width={3000}
                      height={3000}
                    />
                  </Link>
                  { hit?.is_sale == true  &&
                    <div className="absolute left-0 px-3 py-4 text-xs font-semibold text-white bg-red-500 rounded-full -top-4">
                      SALE
                    </div>
                  }
                </div>
                <div className="w-full">
                  <Link href={process.env.APP_URL + `/report-store/${hit.slug}`} target="_blank">
                    <h3 className="mb-2 text-base font-semibold lg:text-md lg:line-clamp-none line-clamp-3">
                      <Highlight attribute="name" hit={hit} />
                    </h3>
                  </Link>
                  <p className="hidden m-0 text-sm md:block dark:text-white line-clamp-2">
                    {hit.short_description}
                  </p>
                  <div className="flex flex-row items-center justify-start gap-4 pt-0 md:pt-2">
                    <BuyNow sampleSlug={hit.name} addingCart={()=>{
                      addingCart(hit._id, 'single-user-license')
                      }} isAdded={isAdded}  />

                    <Link href={process.env.APP_URL + "/sample-request/" + hit.slug} target="_blank">
                      <span className="md:uppercase capitalize cursor-pointer md:text-sm text-xs font-semibold md:text-[#dc2538] text-[#f4be26]">
                        <FontAwesomeIcon className="color-[#1b5df3] pr-2" icon={faFile} />
                        Request Sample Page
                      </span>
                    </Link>

                    {/* <div className="md:uppercase capitalize hidden md:block cursor-pointer md:text-sm text-xs font-semibold text-[#1b5df3]" onClick={() => { buyNowClick(hit._id, 'single-user-license') }}>
                      <FontAwesomeIcon className="color-[#1b5df3] pr-2" icon={faCreditCard} />
                      Buy Now
                    </div> */}
                  </div>
                </div>
                {/* <div className="items-center hidden text-center lg:flex">
                  <div className="font-semibold">
                    FROM
                    <p className="m-0 whitespace-nowrap">
                      {(hit.prices).map((data) => {
                        return (
                          <>
                            {data?.price_type_id === 'single-user-license' ? <>{data?.is_discounted ? <><p className='text-red-500 line-through text-[14px]'>${data?.price}</p> <span className="text-[#f58652] font-bold">${data?.discounted_price}</span></> : <p className="text-[#f58652]">${data?.price}</p>}</> : null}
                          </>
                        )
                      })}
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>}
    </>
  ));

  const ResultsCount = connectStats(({ nbHits }) => (
    <>
      <div className='flex justify-between h-5 mb-5'>
        <div className="flex items-center mt-3">
          <FontAwesomeIcon className="color: #1b5df3 px-2" icon={faChartLine} />
          <p className="text-sm font-semibold">{nbHits} results found {query ? <>for `${query}`</> : ""}</p>
        </div>
        <div className="flex items-center mt-3">
          <span className="px-2 text-xs font-semibold">Sort By : </span>
          <SortBy
            defaultRefinement="reports"
            items={[
              {
                value: 'reports',
                label: 'Most relevant'
              },
              {
                value: 'sortBy',
                label: 'Price (Asc)'
              },
              {
                value: 'instant_search_price_desc',
                label: 'Price (Desc)'
              },
              {
                value: 'published_on',
                label: 'Published On'
              },
              {
                value: 'a-z',
                label: 'A-Z'
              },
              {
                value: 'z-a',
                label: 'Z-A'
              },
            ]}
          />
        </div>
      </div>
    </>
  ));

  const [DataLoading, setDataLoading] = useState(true);
  const [latestData, setLatestData] = useState(true);

  const Results = connectStateResults(
    ({ searchState, searchResults, children, fields, options }) => {


      // if(latestData!=searchResults){
      //   if (searchResults && searchResults.nbHits !== 0) {
      //     setDataLoading(false);
      //   }
      //   setLatestData(searchResults)
      // }
      if (searchResults && searchResults.nbHits !== 0) {
        setDataLoading(false);
      }

      if (DataLoading) {
        return (
          <div className="my-5 text-center">
            <h6 className="text-xl font-semibold">
              Loading...
            </h6>
          </div>
        );
      }


      return searchResults && searchResults.nbHits !== 0 ? (
        children
      ) : (
        <>
          <div className='my-5 text-center'>
            <h6 className="text-xl font-semibold">
              Results found for :
              <span className="text-[16px]">{searchState.query}</span>
            </h6>
          </div>
          <div className="text-center">
            <p>Your search query for <b>{searchState.query}</b> did not fetch any results. We will check our internal report store and will contact you with the details of reports matching your keywords.</p>
            <p>Kindly provide the details so that we can send the appropriate sample pages.</p>
          </div>
          <div className="p-4 border border-gray-400 border-dotted">
            <CallBackForm
              title="Contact Us"
              description=""
              fields={fields}
              options={options}
              page_name="Contact Us"
              form_name="contact-us-form"
              endpoint="/enquiry/open-create"
              slug={slug}
            />
          </div>
        </>
      );
    }
  );

  const updatingState = () => {
    getCart({
      "tmp_id": localStorage.getItem('access_token'),
      "user_id": ""
    }).then((res) => {
      dispatch(addItemToCart(res.data?.data));
    })
  }

  const addingCart = (report_id, selectedPriceTypeId) => {
    const token = localStorage.getItem('access_token');
    addCart({
      "product_id": report_id,
      "tmp_id": token,
      "user_id": "",
      "license_id": selectedPriceTypeId
    }).then((res_data) => {
      updatingState()
      Toast('Cart Updated!')
      
    })
  }

  const buyNowClick = (report_id, selectedPriceTypeId) => {
    const token = localStorage.getItem('access_token');
    addCart({
      "product_id": report_id,
      "tmp_id": token,
      "user_id": "",
      "license_id": selectedPriceTypeId
    }).then((res_data) => {
      updatingState()
      router.push('/checkout')
    })
  }
  const options = {
    btn_name: "Submit"
  }
  const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/
  const fields = [
    {
      name: 'name',
      label: 'Name',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'email',
      type: 'email',
      label: 'Email',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'phone',
      label: 'Phone',
      validation: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
      customClass: 'col-span-12'
    },
    {
      name: 'message',
      label: 'Message',
      type: 'textarea',
      customClass: 'col-span-12'
    },
  ];
  return (
    <>
      <Navbar />
      <div className="mt-65">
        {/*  */}
        <div className={`w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto border-b`}>
          <div className='grid grid-cols-12'>
            <div className='col-span-12'>
              <div className="py-4 text-sm">
                <ul className="flex items-center p-0">
                  <li className="flex items-center whitespace-nowrap">
                    <Link href="/" className="text-[#1b5df3]  ">
                      <FontAwesomeIcon className='pr-4' icon={faHome} size="sm" />
                      Home <FontAwesomeIcon className='px-2 text-gray-400' size="sm" icon={faChevronRight} />
                    </Link>
                    Report Store
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        {/*  */}
      </div>
      <ToastContainer {...toastConfig} />
      <InstantSearch searchClient={searchClient} indexName="reports" >
        <Configure hitsPerPage={12} />
        <div className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
          <div className="grid grid-cols-12 gap-4" >
            {
              isLoading === true ? <><div className="flex items-center justify-center min-h-screen col-span-12">
                <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              </div>
              </> : <>
                <div className="col-span-12 lg:col-span-3" >
                  <div className="lg:hidden">
                    <button onClick={toggleSection} className={`mobile-toggle mb-4 ${expanded ? 'expanded' : ''}`}>
                      <span className="text-lg font-semibold">REFINE BY</span>
                      <FontAwesomeIcon icon={faFilter} className="border p-2 rounded border-black border-[1px] text-[#1b5df3]" />
                    </button>
                  </div>
                  <div className={`${expanded ? '' : 'hidden'} lg:block`}>
                    <div className="flex items-center justify-between w-full mb-6">
                      <p className="m-0 font-semibold">Filters</p>
                      <p className="m-0">
                        <ClearRefinements translations={{
                          reset: (
                            <>
                              &#x2715; Reset All Filters
                            </>
                          ),
                        }} />
                      </p>
                    </div>
                   
                    <div className={(expanded)?'block':'hidden'}>
                      <div className="p-4 mb-2 border rounded filter-border" key={1}>
                        <button
                          className="flex justify-between w-full text-sm font-semibold text-left focus:outline-none"
                          onClick={() => togglePanel(0)}
                        >
                          INDUSTRIES
                          <FontAwesomeIcon
                            icon={faAngleDown}
                            size="lg"
                            style={{ color: 'black', width: '20px', paddingRight: '10px' }}
                            className={`transition-transform duration-300 transform ${expandedStates[0] ? 'rotate-180' : 'rotate-0'}`}
                          />
                        </button>

                        <div className={`overflow-hidden transition-all duration-300 ${expandedStates[0] ? 'max-h-auto' : 'max-h-0'}`}>
                          <hr className="mt-2" />
                          <RefinementList limit={60} attribute="industries.value" />
                        </div>
                      </div>
                      <div className="p-4 mb-2 border rounded filter-border" key={1}>
                        <button
                          className="flex justify-between w-full text-sm font-semibold text-left focus:outline-none"
                          onClick={() => togglePanel(1)}
                        >
                          CATEGORIES
                          <FontAwesomeIcon
                            icon={faAngleDown}
                            size="lg"
                            style={{ color: 'black', width: '20px', paddingRight: '10px' }}
                            className={`transition-transform duration-300 transform ${expandedStates[1] ? 'rotate-180' : 'rotate-0'}`}
                          />
                        </button>
                        <div className={`overflow-hidden transition-all duration-300 ${expandedStates[1] ? 'max-h-auto' : 'max-h-0'}`}>
                          <hr className="mt-2" />
                          <RefinementList attribute="categories.value" limit={60} defaultRefinement={defaultCategory} />
                        </div>
                      </div>

                      {/* <div className="hidden">
                        <RefinementList attribute="keywords.name" limit={60} defaultRefinement={defaultTag} />
                      </div> */}

                      <div className="p-4 mb-2 border rounded filter-border">
                        <button
                          className="flex justify-between w-full text-sm font-semibold text-left focus:outline-none"
                          onClick={() => togglePanel(2)}
                        >
                          THERAPEUTIC AREAS
                          <FontAwesomeIcon icon={faChevronDown} size="lg" style={{ color: 'black', width: '20px', paddingRight: '10px' }}
                            className={`transition-transform duration-300 transform ${expandedStates[2] ? 'rotate-180' : 'rotate-0'
                              }`}
                          />
                        </button>
                        <div
                          className={`overflow-hidden transition-all duration-300 ${expandedStates[2] ? 'max-h-auto' : 'max-h-0'
                            }`}
                        >
                          <hr className="mt-2" />
                          <RefinementList attribute="therapeutic_areas.value" limit={60} defaultRefinement={defaultTharea} />
                        </div>
                      </div>

                      <div className="p-4 mb-2 border rounded filter-border">
                        <button
                          className="flex justify-between w-full text-sm font-semibold text-left focus:outline-none"
                          onClick={() => togglePanel(5)}
                        >
                          GEOGRAPHIES
                          <FontAwesomeIcon icon={faChevronDown} size="lg" style={{ color: 'black', width: '20px', paddingRight: '10px' }}
                            className={`transition-transform duration-300 transform ${expandedStates[5] ? 'rotate-180' : 'rotate-0'
                              }`}
                          />
                        </button>
                        <div
                          className={`overflow-hidden transition-all duration-300 ${expandedStates[5] ? 'max-h-auto' : 'max-h-0'
                            }`}
                        >
                          <hr className="mt-2" />
                          <RefinementList limit={60} attribute="geographies.value" />
                        </div>
                      </div>

                      <div className="p-4 border rounded filter-border">
                        <button
                          className="flex justify-between w-full text-sm font-semibold text-left focus:outline-none"
                          onClick={() => togglePanel(4)}
                        >
                          PRICE RANGE
                          <FontAwesomeIcon icon={faChevronDown} size="lg" style={{ color: 'black', width: '20px', paddingRight: '10px' }}
                            className={`transition-transform duration-300 transform ${expandedStates[4] ? 'rotate-180' : 'rotate-0'
                              }`}
                          />
                        </button>

                        <div
                          className={`overflow-hidden transition-all px-2 duration-300 ${expandedStates[4] ? 'max-h-auto' : 'max-h-0'
                            }`}
                        >
                          <hr className="my-3" />
                          <div className="px-2">
                            <CustomPriceRangeSlider attribute="prices.price" />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-9">
                  <h1 className="mb-3 text-xl font-semibold">Healthcare and Medtech Research Reports</h1>
                  <div className="relative">
                    <SearchBox />
                    <span className="search-icon-alg"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                    <span className="voiceText text-[14px]">Voice Search :</span>
                    <VoiceSearch
                      searchAsYouSpeak={false}
                      translations={{
                        buttonTitle: 'Voice Search',
                        disabledButtonTitle: 'Voice Search Disabled',
                      }}
                    />
                  </div>
                  <ResultsCount />
                  <div className="mt-6">
                    <Results fields={fields} options={options}>
                      <CustomHits />
                    </Results>
                  </div>

                  <div onClick={(e) => setTop(true)}>
                    <Pagination showLast translations={{
                      ariaPage(currentRefinement) {
                        if (top === true) {
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                          });
                        }
                      },
                    }} />
                  </div>
                </div>
              </>
            }
          </div>
        </div>
      </InstantSearch>
      <Footer />
    </>
  );
};

ReportStore.getInitialProps = async (NextPageContext) => {
  const slugData = NextPageContext.pathname
  try {
    const response = await axios.get(process.env.API_URL + '/meta' + slugData);
    return {
      title: (response?.data.meta_title) ? response?.data.meta_title : "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
      description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
      keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
    }
  } catch (error) {
    console.error('Error fetching data:', error.message);
    return {
      title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
      description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
      keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
    };
  }
}

export default ReportStore;


